const BaseModule = require('../../90_utils/base/BaseModule');

class AccordionToggle extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$button = this.$el.find('button');
		this.$accordionParent = this.$el.closest('[data-accordion-toggle-parent]');

		if(!this.$accordionParent.length){ this.$accordionParent = this.$el.parent(); }
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){
		this.$button.on('click', $.proxy(this._onClick, this));
	}

	_removeListeners(){
		this.$button.off('click', $.proxy(this._onClick, this));
	}

	// listener methods

	_onClick(e){
		this.toggle();
	}

	//

	toggle(){
		if(this.$el.hasClass('is-active')){
			this.$el.removeClass('is-active');
			this.$accordionParent.removeClass('is-expanded');
		}
		else {
			this.$el.addClass('is-active');
			this.$accordionParent.addClass('is-expanded');
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){
	}
}

module.exports = AccordionToggle;
